import { api, formatApiError } from "./providers";
import { toast } from "sonner";

/**
 * Download a multi-document PDF bundle.
 * @param {Array<{type:'quote'|'invoice'|'aufmass', id:string}>} items
 * @param {string} filename — without .pdf suffix
 * @param {string} lang — 'de' or 'en'
 */
export async function downloadPdfBundle(items, filename = "bundle", lang = "de") {
  if (!items || items.length === 0) {
    toast.info(lang === "de" ? "Keine Dokumente ausgewählt." : "No documents selected.");
    return;
  }
  try {
    const res = await api.post(
      "/pdf-bundle",
      { items, filename, lang },
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename.endsWith(".pdf") ? filename : `${filename}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success(
      lang === "de"
        ? `Bundle mit ${items.length} Dokument(en) erstellt`
        : `Bundle with ${items.length} document(s) created`
    );
  } catch (err) {
    toast.error(formatApiError(err.response?.data?.detail) || err.message);
  }
}

/** Download all docs of a customer as a project mappe. */
export async function downloadCustomerBundle(customerId, customerName = "kunde", lang = "de") {
  try {
    const res = await api.get(`/customers/${customerId}/project-bundle.pdf`, {
      params: { lang },
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    const safe = (customerName || "kunde").replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 50);
    a.download = `Projektmappe_${safe}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    toast.error(formatApiError(err.response?.data?.detail) || err.message);
  }
}
